import { HugeiconsIcon } from '@hugeicons/react'
import { CrownIcon } from '@hugeicons/core-free-icons'
import { Event } from '@nostr/tools/wasm'
import { useTranslation } from 'react-i18next'

export default function PremiumBadge({ event }: { event: Event }) {
  const { t } = useTranslation()

  if (!event.tags.some(([tagName]) => tagName === 'nip63')) return null

  return (
    <div
      className="rounded-full bg-yellow-400/10 px-2 py-0.5 flex items-center gap-1"
      title={t('Premium content (NIP-63)')}
    >
      <HugeiconsIcon icon={CrownIcon} size={12} className="text-yellow-600 dark:text-yellow-400" />
      <span className="text-xs leading-none text-yellow-600 dark:text-yellow-400 font-medium">
        {t('Premium')}
      </span>
    </div>
  )
}
